import { LearnMore } from 'components/shared/LearnMore/LearnMore';

import { connectTutorial } from './Tutorial.connect';

export const TutorialLink = connectTutorial(LearnMore);
TutorialLink.displayName = 'TutorialLink';
